<template>
  <div class="big">
    <div class="page_title flex_between">
      <span>员工任务详情</span>
      <el-button
        type="primary"
        style="width: 92px"
        size="medium"
        @click="back"
      >返回</el-button>
    </div>
    <div style="padding: 20px">
      <div class="container">
        <div>
          <span class="gray">员工号</span>
          <span style="margin-right:50px">{{info.recommender_code}}</span>
          <span class="gray">员工姓名</span>
          <span style="margin-right:50px">{{info.recommender_name}}</span>
          <span class="gray">员工手机号</span>
          <span>{{info.phone}}</span>
        </div>
        <div style="margin:15px 0">
          <span class="gray">任务周</span>
          <el-date-picker
            v-model="date"
            type="week"
            format="yyyy 第 WW 周"
            value-format="yyyy-MM-dd"
            :clearable="false"
            :picker-options="pickerOptions"
            @change="(value)=>{return changeWeek(value,1)}"
            style="width: 160px; margin-left: 6px"
          >
          </el-date-picker>
        </div>
        <div>
          <span class="week_data">{{weekData}}</span>
          <span class="gray">任务人数</span>
          <span style="margin-right:50px;color:#FF7430">{{info.user_num}}</span>
          <span class="gray">达标用户数</span>
          <span style="margin-right:50px;color:#FF7430">{{info.auth_count}}</span>
        </div>
        <div style="text-align: left;margin:20px 0 10px">
          <span>本周注册/达标用户绑定名单</span>
        </div>

        <div style="border: solid 1px #c9cbd6;">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1200px"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column
              prop="nick_name"
              label="用户昵称"
            />
            <el-table-column
              prop="phone"
              label="手机号"
            />

            <el-table-column
              prop="reg_time"
              label="注册时间"
            />
            <el-table-column
              prop="first_login_time"
              label="首次登录APP/小程序时间"
            />
            <el-table-column label="邀请渠道">
              <template slot-scope="scope">
                <span v-if="scope.row.invitation_channel==1">用户（业务员）</span>
                <span v-if="scope.row.invitation_channel==2">医生</span>
                <span v-if="scope.row.invitation_channel==3">用户（关联用户）</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="invitee"
              label="邀请人"
            />
          </el-table>
        </div>
        <div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum"
            style="margin:20px 0"
          ></el-pagination>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import dayjs from 'dayjs';
export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      info: {},
      week: '',
      date: '',
      weekData: '',
      pickerOptions: {
        firstDayOfWeek: 1
      },
      recommender_code: this.$route.query.recommender_code
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  created() {
    let date = this.$route.query.date;
    this.changeWeek(date);
    this.date = date;
  },
  methods: {
    //改变周
    changeWeek(value) {
      let now = new Date(value);
      let now_day = now.getDay();
      if (now_day == 0) {
        now_day = 7;
      }
      let now_time = now.getTime();
      let monDay = dayjs(
        new Date(now_time + 24 * 60 * 60 * 1000 * (1 - now_day))
      ).format('MM-DD');
      let sunDay = dayjs(
        new Date(now_time + 24 * 60 * 60 * 1000 * (7 - now_day))
      ).format('MM-DD');

      let d1 = new Date(value);
      let d2 = new Date(value);
      d2.setMonth(0);
      d2.setDate(1);
      let rq = d1 - d2;
      let days = Math.ceil(rq / (24 * 60 * 60 * 1000));
      let num = Math.ceil(days / 7);
      let year = dayjs(value).year();

      this.weekData = year + '第' + num + '周 ' + monDay + '~' + sunDay;
      this.week = year + '-' + monDay + '~' + year + '-' + sunDay;
      this.getInfo();
      this.getList();
    },
    //员工详情
    getInfo() {
      let data = {
        recommender_code: this.recommender_code,
        week: this.week
      };
      this.axios.post('platform/Activity/getWeekUserInfo', data).then((res) => {
        this.info = res.data.info;
        this.info.auth_doctor_num = this.info.auth_doctor_num
          ? this.info.auth_doctor_num
          : '该周无任务';
      });
    },
    //获取列表
    getList() {
      let data = {
        recommender_code: this.recommender_code,
        week: this.week,
        page: this.currentPage,
        pageNumber: this.pagesize
      };
      this.axios.post('platform/Activity/weekUserList', data).then((res) => {
        this.totalNum = res.data.total;
        this.tableData = res.data.list.map((item) => {
          item.reg_time = dayjs.unix(item.reg_time).format('YYYY-MM-DD HH:mm');
          item.first_login_time = item.first_login_time
            ? dayjs.unix(item.first_login_time).format('YYYY-MM-DD HH:mm')
            : '';
          return item;
        });
      });
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    back() {
      history.back();
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  text-align: left;
}
.gray {
  color: #747981;
  margin-right: 10px;
}
.week_data {
  font-weight: 700;
  margin-right: 20px;
}
</style>